import React, { useState } from 'react'
import { Button, Tab } from "semantic-ui-react";
import { BasicModal } from "../../../components/Shared";
import { ListDocument, DocumentForm } from "../../../components/Admin/Document";
import "./Document.scss";

export function Document() {

  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(false);

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onReload = () => setReload((prevState) => !prevState);

  const panes = [
    {
      render: () => (
        <Tab.Pane attached={false}>
          <ListDocument reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <>
      <div className="document-page">
        <Button className="document-page__add" primary onClick={onOpenCloseModal}>
          Nuevo documento
        </Button>
        <Tab menu={{ secondary: true }} panes={panes} />
      </div>
      <BasicModal show={showModal} close={onOpenCloseModal} title="Crear documento">
        <DocumentForm onClose={onOpenCloseModal} onReload={onReload} />
      </BasicModal>
    </>
  )
}
